import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "@mui/material/Button";
import type { ArticleTopicInfo, PublicationItemInfo } from "./useTaskDetailSubscription";
import type { ActionState, PreviewSibling, RestartUnfinishedUnitsState } from "./useTaskDetailActions";
import { IfPermission } from "../../auth/IfPermission";
import { ArticleTopicRow } from "./ArticleTopicRow";
import type { JSX } from "react";

export const STATUS_COLORS: Record<ArticleTopicInfo["status"], "default" | "warning" | "info" | "success" | "error"> = {
  queued: "default",
  in_progress: "info",
  completed: "success",
  failed: "error",
};

export function ArticleTopicsSection(props: {
  articleTopics: ArticleTopicInfo[];
  publicationItems: PublicationItemInfo[] | null;
  onRegenerate: (unitId: string) => void;
  regenerateState: ActionState;
  onRestartUnfinished: () => void;
  restartUnfinishedState: RestartUnfinishedUnitsState;
  onViewVariation: (variationId: string, siblings: PreviewSibling[]) => void;
}) {
  let articleTopicsSection: JSX.Element | null;
  if (props.articleTopics.length === 0) {
    articleTopicsSection = null;
  } else {
    const hasUnfinishedUnit = props.articleTopics.some(
      (topic) => topic.status === "failed" || topic.status === "in_progress",
    );
    const canRestartUnfinished = hasUnfinishedUnit && props.publicationItems === null;
    const isRestartUnfinishedLoading = props.restartUnfinishedState.kind === "loading";
    articleTopicsSection = (
    <Box mb={3}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="h6">Уникальные статьи</Typography>
        {canRestartUnfinished && (
          <IfPermission permission="generation.manage">
            <Button
              size="small"
              variant="outlined"
              color="warning"
              onClick={props.onRestartUnfinished}
              disabled={isRestartUnfinishedLoading}
            >
              {isRestartUnfinishedLoading ? "…" : "Перезапустить незавершённые"}
            </Button>
          </IfPermission>
        )}
      </Stack>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Тема</TableCell>
            <TableCell>Заголовок</TableCell>
            <TableCell align="right">Вариаций</TableCell>
            <TableCell>Статус</TableCell>
            <TableCell>Действия</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.articleTopics.map((topic) => (
            <ArticleTopicRow
              key={topic.id}
              topic={topic}
              publicationItems={props.publicationItems}
              onRegenerate={props.onRegenerate}
              regenerateState={props.regenerateState}
              onViewVariation={props.onViewVariation}
            />
          ))}
        </TableBody>
      </Table>
    </Box>
  );
  }
  return articleTopicsSection;
}
